@if (soldTo) {
  <app-contract-steps-bar [soldTo]="soldTo"></app-contract-steps-bar>
}
@if (productSku) {
  <h6>{{ 'my-contracts.my-contracts-header-label' | translate }}</h6>
  <app-product-base-info [productSku]="productSku"></app-product-base-info>
}
<h4 [attr.data-test]="'title-myInstalledBase'">{{ 'my-installed-base.title' | translate }}</h4>
@if (isCpqEnabled && isSparePartsEnabled && !soldTo) {
  <p [attr.data-test]="'desc-myInstalledBaseDesc'" class="description">{{ 'my-installed-base.description' | translate }}</p>
  <div class="bare-list tabs__list">
    @for (tab of tabs; track tab) {
      <h6 class="tabs__item" [attr.data-test]="'tab-' + tab" [ngClass]="{'is-active is-active__bar': currentTab === tab}" (click)="changeTab(tab)">
        {{ 'my-installed-base.' + tab + '-tab-title' | translate }}
      </h6>
    }
  </div>
  @if (currentTab === EInstalledBaseTabs.CONTRACTS) {
    <app-page-my-contracts
      [installedBaseSystemData]="cpqEquipments"
      [installBaseLoading]="cpqEquipmentsLoading"
      [isCpqEnabled]="isCpqEnabled"
      [soldTo]="soldTo"
      [productSku]="productSku"
      [modalitiesAndMaterialNumbers]="cpqModalitiesAndMaterialNumbers">
    </app-page-my-contracts>
  }
  @if (currentTab === EInstalledBaseTabs.EQUIPMENT) {
    <app-my-equipment
      [isCartOperationInProgress]="isCartOperationInProgress"
      [loadingCartDataInProgress]="loadingCartDataInProgress"
      [installedBaseSystemData]="sparePartsEquipments"
      [installBaseLoading]="sparePartsEquipmentsLoading"
      [soldTo]="soldTo"
      [productSku]="productSku"
      [isReorderPending]="isReorderPending"
      [companyRoles]="companyRoles">
    </app-my-equipment>
  }
} @else {
  @if (isCpqEnabled) {
    <p class="description">{{ 'my-contracts.description' | translate }}</p>
    <app-page-my-contracts
      class="my-contracts"
      [installedBaseSystemData]="cpqEquipments"
      [installBaseLoading]="cpqEquipmentsLoading"
      [isCpqEnabled]="isCpqEnabled"
      [soldTo]="soldTo"
      [productSku]="productSku"
      [modalitiesAndMaterialNumbers]="cpqModalitiesAndMaterialNumbers">
    </app-page-my-contracts>
  }
  @if (isSparePartsEnabled && myInstallBaseFlowEnabled) {
    <app-my-equipment
      class="my-equipment"
      [isCartOperationInProgress]="isCartOperationInProgress"
      [loadingCartDataInProgress]="loadingCartDataInProgress"
      [installedBaseSystemData]="sparePartsEquipments"
      [installBaseLoading]="sparePartsEquipmentsLoading"
      [soldTo]="soldTo"
      [productSku]="productSku"
      [isReorderPending]="isReorderPending"
      [companyRoles]="companyRoles">
    </app-my-equipment>
  }
}
